import { useTranslation } from 'react-i18next'

import { QA_NAME_EDIT_BTN } from '../../../../constants/qa'
import { TableControlIcon } from '../../TableControlIcon'

import EditIcon from '../../../../icons/edit.svg'

function TableConfigButton({
  qaName = QA_NAME_EDIT_BTN,
  tooltip = 'Table.EditBtnKey',
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <TableControlIcon
      {...restProps}
      Icon={EditIcon}
      qaName={qaName}
      tooltip={t(tooltip)}
    />
  )
}

export default TableConfigButton
